import React, { useEffect, useState } from "react";
// import AddUserModal from "./AddUserModal";
import styles from "./escrowManagement.module.css";
import GetEscrowDetails from "./GetEscrowDetails/GetEscrowDetails";
import EscrowView from "./EscrowView/EscrowView";
import { useAllProduct } from "../../api-context/commonApiContext";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../../reusable/loader/FullScreenLoader";
const EscrowManagement = () => {
  const { escrowList, setRefreshData,loading } = useAllProduct();
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [showModal, setShowModal] = useState(false);
  const [addEscrow, setAddEscrow] = useState(false);
  const [selectedEscrow, setSelectedEscrow] = useState({});
  const [escrowView, setEscrowView] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  console.log("heyyy-->", escrowList);
  const filteredEscrows = escrowList?.filter((item) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      item?.main_escrow_id?.toLowerCase().includes(searchLower) ||
      item?.registered_company_name?.toLowerCase().includes(searchLower) ||
      item?.primary_contact_email_id?.toLowerCase().includes(searchLower)
    );
  });

  const paginatedReports = filteredEscrows?.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className="d-flex justify-content-between">
        <div className={`${styles.title} mt-5`}>Escrow Management </div>
        <div
          className={`${styles.bulkPayoutButton} mt-5 d-flex justify-content-center align-items-center p-2 gap-2`}
          onClick={() => {
            setAddEscrow({});
            // setShowModal(true);
            navigate("/escrow-management/add-escrow");
          }}
        >
          <img
            className={`${styles.plusCircleIcon} pe-1`}
            alt=""
            src="/pluscircle.svg"
          />
          Add Escrow
        </div>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>Escrow List</h3>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.filterLabel}
                      placeholder="Search..."
                      type="text"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(0); // reset pagination on search
                      }}
                    />
                  </div>
                </div>
                <div className={styles.reLoadTable}>
                  <img
                    className={styles.reloadIcon}
                    loading="lazy"
                    alt=""
                    src="/reload.svg"
                    onClick={() => {
                      console.log("helloo World");
                      setRefreshData(true);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.headerSeparator} />
          </div>

          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}> CREATED AT</div>
              <div className={styles.cell}> ESCROW ID</div>
              <div className={styles.cell}> NAME OF THE COMPANY</div>
              <div className={styles.cell}> PRIMARY EMAIL ID </div>
              <div className={styles.cell}> ACTION</div>
            </div>

            {paginatedReports?.length > 0 ? (
              paginatedReports?.map((report, index) => (
                <div className={styles.tableRow} key={index}>
                  <div className={styles.cell}>{report?.created_date}</div>
                  <div className={styles.cell}>{report?.main_escrow_id}</div>
                  <div className={styles.cell}>
                    {report?.registered_company_name}
                  </div>
                  <div className={styles.cell}>
                    {report?.primary_contact_email_id}
                  </div>
                  <div className={styles.cell}>
                    <span
                      className={styles.actionButton}
                      onClick={() => {
                        // setSelectedEscrow(report);
                        // setEscrowView(true);
                        console.log("report", report);

                        navigate(`/escrow-management/${report.main_escrow_id}`);
                      }}
                    >
                      view
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div
                className={`d-flex justify-content-center align-items-center py-4`}
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  height: "30vh",
                }}
              >
                <div className=" w-100">No data available</div>
              </div>
            )}
          </div>
        </section>
        <TablePagination
          component="div"
          count={filteredEscrows?.length || 0}
          page={currentPage}
          onPageChange={handleChangePage}
          rowsPerPage={10}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            "& .MuiTablePagination-selectLabel": {
              marginTop: "14px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "14px",
            },
          }}
        />
      </div>
    </>
  );
};

const ButtonWithIcon = ({ icon, text }) => (
  <div className={styles.filterLinesParent}>
    <img className={styles.filterLinesIcon} alt="" src={`/${icon}`} />
    <div className={styles.labelText}>{text}</div>
  </div>
);

export default EscrowManagement;
